import Box from '@mui/material/Box'
import { useLocation, useNavigate } from 'react-router-dom'
import Column1 from './unsubmitted/Column1'
import Column2 from './unsubmitted/Column2'

export default function UnsubmittedReportsList({
  muiIcon,
  reportID,
  reportName,
  reportType,
  startDate,
  endDate,
  totalAmount,
  numberExpenses,
  status,
}) {
  const location = useLocation()
  const navigate = useNavigate()
  const handleClick = (reportID) => {
    navigate(`/app/claim/reports/${reportID}`, {
      state: { currentLocation: location },
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { sm: 'row', xs: 'column' },
        justifyContent: 'space-between',
        alignItems: { md: 'center', xs: 'space-between' },
        p: 2,
        gap: 1,
        borderBottom: 1,
        borderColor: 'gray-line.main',
        cursor: 'pointer',
        width: '100%',
      }}
      onClick={() => handleClick(reportID)}
    >
      <Column1
        muiIcon={muiIcon}
        reportName={reportName}
        reportType={reportType}
        startDate={startDate}
        endDate={endDate}
      />
      <Column2
        reportID={reportID}
        variant={1}
        status={status}
        totalAmount={totalAmount}
        numberExpenses={numberExpenses}
      />
    </Box>
  )
}
